// removed by extract-text-webpack-plugin
module.exports = {"checkboxes":"_2vDTcQzs9SlZRo9bwopC4S"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/molecules/SearchFilter/style.css
// module id = 232
// module chunks = 101